document.addEventListener("DOMContentLoaded", function () {

  // Review Slider
var swiper = new Swiper(".expertReviews-block-slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-button-next-reviews",
      prevEl: ".swiper-button-prev-reviews",
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
  });


  // Video Slider

  var swiper = new Swiper(".videoProduct-block", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true, 
    breakpoints: {
      399: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      499: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 2.5,
        spaceBetween: 15,
      },
      786: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1099: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

});
